
interface CardSomatorioProps {
    numeroEmbarque: string;
    somatorioFreteFiscal: string;
    somatorioFreteMotorista: string;
    somatorioIcms: string;
    somatorioKm: string;
    somatorioExcedeuPisoAntt: string;
    somatorioMargem: string;
}

function CardSomatorio({
    numeroEmbarque,
    somatorioIcms,
    somatorioKm,
    somatorioExcedeuPisoAntt,
    somatorioMargem,
    somatorioFreteFiscal,
    somatorioFreteMotorista,
}: CardSomatorioProps) {
    return (
        <div className="container-embarque-card">
            <div className="card-embarque">
                <div className="card-header-embarque">
                    Número de Viagens
                </div>
                <div className="card-body-embarque">{numeroEmbarque}</div>
            </div>
            <div className="card-embarque">
                <div className="card-header-embarque">
                    Somatório Frete Fiscal
                </div>
                <div className="card-body-embarque">
                    {somatorioFreteFiscal}
                </div>
            </div>
            <div className="card-embarque">
                <div className="card-header-embarque">
                    Somatório Freta Motorista
                </div>
                <div className="card-body-embarque">
                    {somatorioFreteMotorista}
                </div>
            </div>
            <div className="card-embarque">
                <div className="card-header-embarque">Somatório Icms</div>
                <div className="card-body-embarque">{somatorioIcms}</div>
            </div>
            <div className="card-embarque">
                <div className="card-header-embarque">Somatório KM</div>
                <div className="card-body-embarque">{somatorioKm}</div>
            </div>
            <div className="card-embarque">
                <div className="card-header-embarque">Soma Piso ANTT</div>
                <div className="card-body-embarque">
                    {somatorioExcedeuPisoAntt}
                </div>
            </div>
            <div className="card-embarque">
                <div className="card-header-embarque">Margem</div>
                <div className="card-body-embarque">{somatorioMargem}</div>
            </div>
        </div>
    );

};

export default CardSomatorio;